import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Clock, ClipboardList } from 'lucide-react';

const SurveyQuestions = () => {
  // Feature locked - Coming Soon
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-slate-900 text-white p-4 shadow-md">
        <div className="max-w-6xl mx-auto flex items-center gap-4">
          <Link to="/admin/dashboard" className="hover:opacity-80">
            <ArrowLeft className="w-6 h-6" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold uppercase" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Survey Questions
            </h1>
            <p className="text-sm text-slate-400">Manage inspection questions</p>
          </div>
        </div>
      </div>
      
      <div className="max-w-2xl mx-auto p-6 mt-12">
        <div className="bg-white rounded-xl shadow-lg p-8 text-center">
          <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ClipboardList className="w-10 h-10 text-purple-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-800 mb-3">Coming Soon</h2>
          <p className="text-slate-600 mb-6">
            Dynamic Survey Questions feature is under development.<br/>
            This will allow you to create custom questions for supervisor inspections.
          </p>
          <div className="bg-slate-100 rounded-lg p-4 text-left text-sm text-slate-600">
            <h4 className="font-bold mb-2">Planned Features:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>Create permanent and temporary survey questions</li>
              <li>Multiple question types (text, yes/no, dropdown, photos)</li>
              <li>View answers in Zone Attendance report</li>
              <li>Separate reports for temporary surveys</li>
            </ul>
          </div>
          <Link 
            to="/admin/dashboard"
            className="inline-block mt-6 px-6 py-3 bg-slate-900 text-white rounded-lg font-bold hover:bg-slate-800"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SurveyQuestions;
